/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathGreater = createReactComponent("outline", "math-greater", "IconMathGreater", [["path", { "d": "M5 18l14 -6l-14 -6", "key": "svg-0" }]]);

export { IconMathGreater as default };
//# sourceMappingURL=IconMathGreater.mjs.map
